export default () => {
    
    return `
    
        <h1 class="show404__title text-center">Obs! Her var det ikke noe innhold</h1>
    
    `;
    
}